import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../api/api'

export const get_admin_orders = createAsyncThunk(
    'order/get_admin_orders',
    async ({ parPage, page, searchValue }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get(`/admin/orders?page=${page}&searchValue=${searchValue}&parPage=${parPage}`, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const get_seller_orders = createAsyncThunk(
    'order/get_seller_orders',
    async ({ parPage, page, searchValue, payment_status, delivery_status, exclude_delivery_status, fromDate, toDate, sellerId }, { rejectWithValue, fulfillWithValue }) => {
        try {
            let url = `/seller/orders/${sellerId}?page=${page}&searchValue=${searchValue}&parPage=${parPage}`;
            
            // Add filter parameters to URL
            if (payment_status && payment_status !== 'all') {
                url += `&payment_status=${payment_status}`;
            }
            if (delivery_status && delivery_status !== 'all') {
                url += `&delivery_status=${delivery_status}`;
            } else if (exclude_delivery_status && exclude_delivery_status !== 'all') {
                url += `&exclude_delivery_status=${exclude_delivery_status}`;
            }
            if (fromDate) {
                url += `&fromDate=${fromDate}`;
            }
            if (toDate) {
                url += `&toDate=${toDate}`;
            }
            
            const { data } = await api.get(url, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const get_admin_order = createAsyncThunk(
    'order/get_admin_order',
    async (orderNumber, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get(`/admin/order/${orderNumber}`, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const get_seller_order = createAsyncThunk(
    'order/get_seller_order',
    async (orderNumber, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get(`/seller/order/${orderNumber}`, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const admin_order_status_update = createAsyncThunk(
    'order/admin_order_status_update',
    async ({ orderNumber, info }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.put(`/admin/order-status/update/${orderNumber}`, info, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const seller_order_status_update = createAsyncThunk(
    'order/seller_order_status_update',
    async ({ orderNumber, info }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.put(`/seller/order-status/update/${orderNumber}`, info, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            // Handle authentication errors specifically for order status updates
            if (error.response && (error.response.status === 401 || error.response.status === 409)) {
                const errorMessage = error.response.data?.error || 'Authentication failed';
                if (errorMessage.includes('Please login') || errorMessage.includes('Authentication failed')) {
                    // Return a specific error type for authentication issues
                    return rejectWithValue({
                        message: 'Authentication error during order status update',
                        type: 'auth_error',
                        originalError: error.response.data
                    });
                }
            }
            return rejectWithValue(error.response.data)
        }
    }
)

export const manual_ftp_upload = createAsyncThunk(
    'order/manual_ftp_upload',
    async (orderNumber, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.post(`/seller/order/manual-ftp-upload/${orderNumber}`, {}, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)





export const OrderReducer = createSlice({
    name: 'order',
    initialState: {
        successMessage: '',
        errorMessage: '',
        totalOrder: 0,
        order: {},
        myOrders: [],
        loader: false
    },
    reducers: {
        messageClear: (state, _) => {
            state.errorMessage = ""
            state.successMessage = ""
        }
    },
    extraReducers: {
        [get_admin_orders.fulfilled]: (state, { payload }) => {
            state.myOrders = payload.orders
            state.totalOrder = payload.totalOrder
        },
        [get_admin_order.fulfilled]: (state, { payload }) => {
            state.order = payload.order
        },
        [admin_order_status_update.rejected]: (state, { payload }) => {
            state.errorMessage = payload.message
        },
        [admin_order_status_update.fulfilled]: (state, { payload }) => {
            state.successMessage = payload.message
        },
        [get_seller_orders.pending]: (state) => {
            state.loader = true
        },
        [get_seller_orders.fulfilled]: (state, { payload }) => {
            state.loader = false
            state.myOrders = payload.orders
            state.totalOrder = payload.totalOrder
        },
        [get_seller_orders.rejected]: (state) => {
            state.loader = false
        },
        [get_seller_order.pending]: (state) => {
            state.loader = true
        },
        [get_seller_order.fulfilled]: (state, { payload }) => {
            state.loader = false
            state.order = payload.order
        },
        [get_seller_order.rejected]: (state) => {
            state.loader = false
        },
        [seller_order_status_update.rejected]: (state, { payload }) => {
            state.errorMessage = payload.message
        },
        [seller_order_status_update.fulfilled]: (state, { payload }) => {
            state.successMessage = payload.message
        },
        [manual_ftp_upload.rejected]: (state, { payload }) => {
            state.errorMessage = payload.message
        },
        [manual_ftp_upload.fulfilled]: (state, { payload }) => {
            state.successMessage = payload.message
        },
    }

})
export const { messageClear } = OrderReducer.actions
export default OrderReducer.reducer